import { ChangeDetectionStrategy, Component, Input, ViewContainerRef, inject } from '@angular/core';
import { Router } from '@angular/router';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import {
  DialogService,
  DialogWidth,
  IconComponent,
  MessageComponent,
} from '@core/user-interface-legacy';

import { OffersArchiveDialogComponent } from './offers-archive-dialog/offers-archive-dialog.component';

@Component({
  selector: 'rt-job-slots-limit-message',
  templateUrl: './job-slots-limit-message.component.html',
  styleUrls: ['./job-slots-limit-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent, IconComponent, TranslatePipe],
})
export class JobSlotsLimitMessageComponent {
  private readonly router = inject(Router);
  private readonly i18n = inject(I18nService);
  private readonly dialogSvc = inject(DialogService);
  private readonly vcRef = inject(ViewContainerRef);

  @Input() public numberOfJobsToArchive: number;
  @Input() public compact: boolean;
  @Input() public altMessage?: string;

  public message: string;

  public ngOnChanges() {
    if (this.numberOfJobsToArchive > 0) {
      this.message = this.i18n.translate(
        'app.pricing.job_slots_dialog.slots_downgrade_limit_jobs',
        {
          jobs: this.numberOfJobsToArchive,
        },
      );
    } else {
      this.message = '';
    }
  }

  public manageOffers() {
    this.dialogSvc.custom(
      OffersArchiveDialogComponent,
      {
        width: DialogWidth.Small,
      },
      null,
      this.vcRef,
    );
  }
}
